import { bootstrapApplication } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {ViewEncapsulation} from '@angular/core';


/*
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));*/
platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    defaultEncapsulation: ViewEncapsulation.None
  })
  .catch(err => console.error(err));
